var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentOptStatus === _vm.optStatusDefs.normal,
              expression: "currentOptStatus===optStatusDefs.normal"
            }
          ],
          staticClass: "main-content tab-billing"
        },
        [
          _c(
            "query-billing",
            {
              key: "queryBilling",
              ref: "queryBilling",
              attrs: {
                identify: "tabBillingSearchItem",
                "view-source": "tabBilling",
                "config-module": "50401",
                "grid-config-module": "19070301",
                "billing-clearing-state-param": "BillingClearingState",
                "billing-job-state-param": "BillingJobState",
                "billing-state-param": "BillingState",
                "default-option-values":
                  _vm.searchConditions.billingDefaultOptions,
                "is-ar": _vm.searchConditions.paymentType,
                oversea: _vm.searchConditions.chargeTypeGroup,
                "show-invoice-state": true,
                "show-controlled-charge": true,
                "show-invoice-no": true,
                "show-fba": false,
                "show-wht": true,
                "has-check-role": true,
                "is-append-query": true,
                "input-date-start": _vm.searchConditions.inputDateStart,
                "input-date-end": _vm.searchConditions.inputDateEnd,
                "internal-charge": _vm.searchConditions.internalCharge,
                type: "both",
                "total-type": "auto"
              },
              on: {
                rowDoubleClicked: _vm.rowDoubleClicked,
                onRowClicked: _vm.onBillingGridItemClick
              },
              scopedSlots: _vm._u([
                {
                  key: "searchAreaHeader",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "app-main-inner-row extension-conditions-form"
                        },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "basicForm",
                              attrs: { inline: "", "label-position": "left" }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: [
                                        "filter_ACTBilling_allBillings",
                                        "filter_ACTBilling_arBillings",
                                        "filter_ACTBilling_apBillings"
                                      ],
                                      expression:
                                        "['filter_ACTBilling_allBillings','filter_ACTBilling_arBillings','filter_ACTBilling_apBillings']"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_PaymentReceiveMethodP"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { no: "19" },
                                      model: {
                                        value: _vm.searchConditions.paymentType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.searchConditions,
                                            "paymentType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "searchConditions.paymentType"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: [
                                                "filter_ACTBilling_arBillings"
                                              ],
                                              expression:
                                                "['filter_ACTBilling_arBillings']"
                                            }
                                          ],
                                          attrs: { label: 1 }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_Receivable"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: [
                                                "filter_ACTBilling_apBillings"
                                              ],
                                              expression:
                                                "['filter_ACTBilling_apBillings']"
                                            }
                                          ],
                                          attrs: { label: 0 }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_Dues")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: [
                                                "filter_ACTBilling_allBillings"
                                              ],
                                              expression:
                                                "['filter_ACTBilling_allBillings']"
                                            }
                                          ],
                                          attrs: { label: -1 }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("CargoMsg.Cargo_All"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: [
                                        "filter_ACTBilling_allRegionalBillings",
                                        "filter_ACTBilling_overseaBillings",
                                        "filter_ACTBilling_localBillings"
                                      ],
                                      expression:
                                        "['filter_ACTBilling_allRegionalBillings','filter_ACTBilling_overseaBillings','filter_ACTBilling_localBillings']"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_BillOfType")
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { no: "20" },
                                      on: { change: _vm.showInvalid },
                                      model: {
                                        value:
                                          _vm.searchConditions.chargeTypeGroup,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.searchConditions,
                                            "chargeTypeGroup",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "searchConditions.chargeTypeGroup"
                                      }
                                    },
                                    [
                                      _vm.showDomestic
                                        ? _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_Domestic"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.showInternational
                                        ? _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_International"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.showAllRegionalBillings
                                        ? _c(
                                            "el-radio",
                                            {
                                              directives: [
                                                {
                                                  name: "permission",
                                                  rawName: "v-permission",
                                                  value: [
                                                    "filter_ACTBilling_allRegionalBillings"
                                                  ],
                                                  expression:
                                                    "['filter_ACTBilling_allRegionalBillings']"
                                                }
                                              ],
                                              attrs: { label: -1 }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("CargoMsg.Cargo_All")
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.showAgentBilling
                                        ? _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_AgentBilling"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ReconciliationTypeP"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { no: "21" },
                                      model: {
                                        value: _vm.billType,
                                        callback: function($$v) {
                                          _vm.billType = $$v
                                        },
                                        expression: "billType"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "job" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_ByJob")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "charge" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_ByFee")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.useOrderCenterMode,
                                      expression: "useOrderCenterMode"
                                    }
                                  ],
                                  attrs: { "label-width": "0" }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { no: "22" },
                                      model: {
                                        value:
                                          _vm.searchConditions.internalCharge,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.searchConditions,
                                            "internalCharge",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "searchConditions.internalCharge"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_InternalCharges"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_BillDateP")
                                  }
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  no: "23",
                                                  type: "date",
                                                  clearable: false,
                                                  "value-format": "yyyy-MM-dd",
                                                  "picker-options":
                                                    _vm.pickerOptions
                                                },
                                                model: {
                                                  value:
                                                    _vm.searchConditions
                                                      .inputDateStart,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.searchConditions,
                                                      "inputDateStart",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "searchConditions.inputDateStart"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("el-col", { attrs: { span: 1 } }, [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { "font-size": "12px" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.Cargo_To")
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  no: "24",
                                                  type: "date",
                                                  clearable: "",
                                                  "value-format": "yyyy-MM-dd",
                                                  "picker-options":
                                                    _vm.pickerOptions
                                                },
                                                model: {
                                                  value:
                                                    _vm.searchConditions
                                                      .inputDateEnd,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.searchConditions,
                                                      "inputDateEnd",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "searchConditions.inputDateEnd"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticStyle: {
                                            "padding-left": "5px"
                                          },
                                          attrs: { span: 7 }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c(
                                                "el-checkbox",
                                                {
                                                  attrs: { no: "25" },
                                                  model: {
                                                    value:
                                                      _vm.allowTwoYearOutside,
                                                    callback: function($$v) {
                                                      _vm.allowTwoYearOutside = $$v
                                                    },
                                                    expression:
                                                      "allowTwoYearOutside"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Billing.billingJob_lockCheckBoxDate"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_ACTBilling_createGroupFromBillings"],
                          expression:
                            "['button_ACTBilling_createGroupFromBillings']"
                        }
                      ],
                      attrs: { no: "1", type: "primary" },
                      on: { click: _vm.createBillingGroupClick }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_NewAccountStatement"))
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_ACTBilling_editBilling"],
                          expression: "['button_ACTBilling_editBilling']"
                        }
                      ],
                      attrs: { no: "2", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.showBillDetailView(undefined, true, false)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_ACTBilling_deleteBilling"],
                          expression: "['button_ACTBilling_deleteBilling']"
                        }
                      ],
                      attrs: { no: "3", type: "danger" },
                      on: { click: _vm.deleteBilling }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_ACTBilling_viewBilling"],
                          expression: "['button_ACTBilling_viewBilling']"
                        }
                      ],
                      attrs: { no: "4", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.showBillDetailView(undefined, true, true)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_View")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_ACTBilling_confirmBilling"],
                          expression: "['button_ACTBilling_confirmBilling']"
                        }
                      ],
                      attrs: { no: "5", type: "primary" },
                      on: { click: _vm.confirmBilling }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_ACTBilling_unconfirmBilling"],
                          expression: "['button_ACTBilling_unconfirmBilling']"
                        }
                      ],
                      attrs: { no: "6", type: "primary" },
                      on: { click: _vm.unConfirmBilling }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CancelConfirm")))]
                  ),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        type: "primary",
                        content: _vm.$t("Billing.billing_recheckTip"),
                        placement: "bottom"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "btn",
                          staticStyle: {
                            display: "inline-block",
                            "margin-right": "5px"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "permission",
                                  rawName: "v-permission",
                                  value: ["button_ACTBilling_recheckBilling"],
                                  expression:
                                    "['button_ACTBilling_recheckBilling']"
                                }
                              ],
                              staticStyle: { "margin-left": "5px" },
                              attrs: { no: "7", type: "primary" },
                              on: { click: _vm.recheckBilling }
                            },
                            [_vm._v(_vm._s(this.$t("Billing.billing_recheck")))]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_ACTBilling_cancelRecheckBilling"],
                          expression:
                            "['button_ACTBilling_cancelRecheckBilling']"
                        }
                      ],
                      attrs: { no: "8", type: "primary" },
                      on: { click: _vm.cancelRecheckBilling }
                    },
                    [_vm._v(_vm._s(this.$t("Billing.billing_cancelRecheck")))]
                  ),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_ACTBilling_printBilling"],
                          expression: "['button_ACTBilling_printBilling']"
                        }
                      ],
                      staticStyle: { margin: "0 5px" },
                      attrs: { no: "9", "split-button": "", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.printBilling(_vm.$t("CargoMsg.Cargo_Print"))
                        },
                        command: _vm.printBilling
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("CargoMsg.Cargo_Print")) + " "
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t("Clearing.PrintByAccountNumber")
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Clearing.PrintByAccountNumber"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.role.createInvoiceFromBilling ||
                  _vm.role.createInvoiceApFromBilling
                    ? _c(
                        "el-button",
                        {
                          attrs: { no: "10", type: "primary" },
                          on: { click: _vm.makeInvoiceEvent }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_Invoicing")) +
                              "/" +
                              _vm._s(_vm.$t("CargoMsg.Cargo_CollectInvoice"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_ACTBilling_writeoffBilling"],
                          expression: "['button_ACTBilling_writeoffBilling']"
                        }
                      ],
                      attrs: { no: "11", type: "primary" },
                      on: { click: _vm.writeoffHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WriteOff")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_ACTBilling_payauthFromCharges"],
                          expression: "['button_ACTBilling_payauthFromCharges']"
                        }
                      ],
                      attrs: { no: "12", type: "primary" },
                      on: { click: _vm.doBillPayment }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("CargoMsg.Cargo_ApplyForPayment")) +
                          " "
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.permissionBtnInvalid,
                          expression: "permissionBtnInvalid"
                        }
                      ],
                      attrs: { no: "13", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.onInvalidClickEvent()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("FinanceManage.international_invalid"))
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "14", type: "primary" },
                      on: { click: _vm.signEvent }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Mark")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "15", type: "primary" },
                      on: { click: _vm.cancelSignEvent }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CancelMark")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.searchConditions.chargeTypeGroup === 1 &&
                            _vm.$checkPermission([
                              "button_billTab_forceDelete"
                            ]),
                          expression:
                            "searchConditions.chargeTypeGroup === 1 && $checkPermission(['button_billTab_forceDelete'])"
                        }
                      ],
                      attrs: { no: "16", type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.forceDeleteHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ForceDelete")))]
                  ),
                  _vm.toExoSystemOC
                    ? _c(
                        "el-button",
                        {
                          attrs: { no: "17", type: "primary" },
                          on: { click: _vm.prePaymentHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OcPrePayment")))]
                      )
                    : _vm._e(),
                  _vm.toExoSystemOC
                    ? _c(
                        "el-button",
                        {
                          attrs: { no: "18", type: "primary" },
                          on: { click: _vm.cancelPrePaymentHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_OcCancelPrePayment"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.role.batchUpload
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "batchUpload" },
                          on: { click: _vm.batchUploadFileHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_BatchUploadFile"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.toExoSystemTp &&
                            _vm.searchConditions.chargeTypeGroup === 1 &&
                            _vm.$checkPermission([
                              "button_ACTBilling_exportPillBilling"
                            ]),
                          expression:
                            "toExoSystemTp && searchConditions.chargeTypeGroup === 1 && $checkPermission(['button_ACTBilling_exportPillBilling'])"
                        }
                      ],
                      attrs: { no: "exportPillBilling", type: "primary" },
                      on: { click: _vm.exportPillBillingHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("PillReport.ExportBillingData")))]
                  ),
                  _vm.qlToFinanceApi &&
                  _vm.$checkPermission(["button_ACTBilling_syncCloud"])
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "25" },
                          on: { click: _vm.syncCloudPlatformFunc }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_SynchronousCloudPlatform")
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.searchConditions.chargeTypeGroup === 1 &&
                            _vm.$checkPermission([
                              "button_ACTBilling_redPunchBilling"
                            ]),
                          expression:
                            "searchConditions.chargeTypeGroup === 1 && $checkPermission(['button_ACTBilling_redPunchBilling'])"
                        }
                      ],
                      attrs: { no: "redPunchBilling", type: "danger" },
                      on: { click: _vm.redPunchBillingHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WriteBack")))]
                  ),
                  _vm.$checkPermission([
                    "button_ACTBilling_billingInvoicePool"
                  ]) && _vm.searchConditions.paymentType === 0
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            no: "showInvoicePoolDialog"
                          },
                          on: { click: _vm.showInvoicePoolDialog }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_InvoicePoolReceiving")
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._l(_vm.instructioinBtns, function(item, index) {
                    return [
                      _c(
                        "el-button",
                        {
                          key: "instruction" + index,
                          attrs: {
                            type: "primary",
                            disabled: !item.allowOperate
                          },
                          on: {
                            click: function($event) {
                              return _vm.onInstructionClick(item)
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$selectByLang(
                                  item.chineseName,
                                  item.englishName,
                                  item.japaneseName
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            ]
          )
        ],
        1
      ),
      _vm.currentOptStatus === _vm.optStatusDefs.billDetailView
        ? _c("bill-detail", {
            attrs: {
              "billing-uuid": _vm.billingUuid,
              "view-billing": _vm.viewBilling,
              "r-type": _vm.billType,
              location: _vm.location,
              "view-source": "bill"
            },
            on: {
              cancel: _vm.backBillingList,
              backBillingList: _vm.backBillingList
            }
          })
        : _vm._e(),
      _vm.currentOptStatus === _vm.optStatusDefs.billGroupDetailView
        ? _c("bill-group-detail", {
            attrs: {
              "view-source": "bill",
              "new-billing-group": _vm.billingGroupProperties.billingGroup,
              "new-billings": _vm.billingGroupProperties.billings,
              "view-billing-group": false,
              location: _vm.location
            },
            on: {
              cancel: function($event) {
                _vm.currentOptStatus = _vm.optStatusDefs.normal
              },
              backBillingList: _vm.backBillingList
            }
          })
        : _vm._e(),
      _vm.writeOffDialog.visible
        ? _c("write-off-dialog", {
            ref: "dgWriteoff",
            attrs: {
              visible: _vm.writeOffDialog.visible,
              title: _vm.title,
              properties: _vm.properties,
              location: _vm.location
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.writeOffDialog, "visible", $event)
              },
              writeoffSuccessHandler: _vm.reloadData
            }
          })
        : _vm._e(),
      _c("bill-payment-dialog", {
        ref: "billPayment",
        attrs: {
          "open-sap-config": false,
          visible: _vm.showBillPaymentDialog,
          "create-submit": true,
          location: _vm.location,
          step: "step2",
          mode: "overview"
        },
        on: {
          "update:visible": function($event) {
            _vm.showBillPaymentDialog = $event
          },
          cancel: _vm.cancelBillPayment
        }
      }),
      _c("make-invoice-dialog", {
        ref: "invoice",
        attrs: { "view-source": "bill", location: _vm.location },
        on: { reloadData: _vm.reloadData }
      }),
      _c("cargo-template-selector-dialog", {
        ref: "cargoTemplateSelectorDialog",
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "pre-print-callback": _vm.prePrintCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("new-bill-payment-dialog", {
        attrs: {
          visible: _vm.billPaymentDialogForH5.visible,
          title: _vm.billPaymentDialogForH5.title,
          "bill-payment-account-id":
            _vm.billPaymentDialogForH5.defaultConditions.accountId,
          "view-source": _vm.billPaymentDialogForH5.source,
          "bill-payment-uuid": _vm.billPaymentDialogForH5.uuid,
          "default-conditions": _vm.billPaymentDialogForH5.defaultConditions
        },
        on: {
          close: function($event) {
            _vm.billPaymentDialogForH5.visible = false
          }
        }
      }),
      _vm.billPaymentDialogForH5.billPaymentDetailProperties.visible
        ? _c("bill-payment-detail-for-h5", {
            ref: "billPaymentDetailForH5",
            attrs: {
              "bill-payment-uuid":
                _vm.billPaymentDialogForH5.billPaymentDetailProperties.uuid,
              title:
                _vm.billPaymentDialogForH5.billPaymentDetailProperties.title,
              visible:
                _vm.billPaymentDialogForH5.billPaymentDetailProperties.visible,
              state:
                _vm.billPaymentDialogForH5.billPaymentDetailProperties.state,
              charges:
                _vm.billPaymentDialogForH5.billPaymentDetailProperties.charges,
              "charges-dirty": true,
              "bill-payment-dirty": true,
              "open-sap-config": false,
              "input-by":
                _vm.billPaymentDialogForH5.billPaymentDetailProperties.inputBy,
              "parent-context": _vm.context,
              location: _vm.location,
              "view-source": "tabBilling"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.billPaymentDialogForH5.billPaymentDetailProperties,
                  "visible",
                  $event
                )
              },
              toPreStep: _vm.toPreStep,
              refreshBillPayment: _vm.refreshBillPaymentH5
            }
          })
        : _vm._e(),
      _c("sign-billing-dialog", {
        attrs: {
          visible: _vm.signBillingDialog.visible,
          "billing-keys": _vm.signBillingDialog.billingKeys
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.signBillingDialog, "visible", $event)
          },
          signBillingCallBack: _vm.signBillingCallBack
        }
      }),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.batchCheckingWindow.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("batch-upload-file", {
        attrs: {
          visible: _vm.cloudFile.visible,
          "redis-key": _vm.cloudFile.redisKey,
          "job-num": _vm.cloudFile.num,
          "page-source": "tabBilling",
          lob: _vm.cloudFile.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          }
        }
      }),
      _vm.invoicePoolDialog.visible
        ? _c("invoice-pool-dialog", {
            attrs: {
              visible: _vm.invoicePoolDialog.visible,
              "seller-tax-name-default-value":
                _vm.invoicePoolDialog.sellerTaxNameDefaultValue,
              "selected-entities": _vm.invoicePoolDialog.selectedEntities,
              "make-invoice-method": _vm.invoicePoolDialog.makeInvoiceMethod,
              operation: _vm.invoicePoolDialog.operation,
              source: _vm.invoicePoolDialog.source
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.invoicePoolDialog, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }